// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import FastClick from 'fastclick'
import router from './router'
import App from './App'
import VueTouch from 'vue-touch'
import InfiniteLoading from 'vue-infinite-loading'
import store from './store'
import './permission' // permission control
import './vux_import'
import './wx_share'
import * as filters from './filters' // global filters
import './utils/base'
import i18n from './lang'
import global_ from './utils/global'
import uploader from 'vue-simple-uploader'
import '@/style/index.less'

FastClick.attach(document.body)
Vue.config.productionTip = false

Vue.use(VueTouch, { name: 'v-touch' })

Vue.use(uploader)

Vue.use(InfiniteLoading, {
  props: {
    direction: 'bottom',
    distance: 1000
  },
  slots: {
    noMore: '全部加载完成', // you can pass a string value,
    noResults: '全部加载完成'
  }
})

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.prototype.GLOBAL = global_

/* eslint-disable no-new */
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js